export default __webpack_public_path__ + "static/media/message.93deaeec.svg";